const configTooltipProvider = toastrConfig => {
	Object.assign(toastrConfig, {
		autoDismiss: false,
		containerId: 'toast-container',
		maxOpened: 0,
		newestOnTop: true,
		positionClass: 'toast-top-right',
		preventDuplicates: false,
		preventOpenDuplicates: false,
		target: 'body',
		allowHtml: true,
	});
};
configTooltipProvider.$inject = ['toastrConfig'];
export default configTooltipProvider;
